export const COMMITTEES_TRANSLATE = {
    committees: {
        breadcrumbName: "Committees",
        messages: {
            create: "Committee added successfully",
            update: "Committee updated successfully",
            delete: "Committee deactivated successfully",
            recover: "Committee restored successfully"
        },
        list: {
            table: {
                columns: {
                    id: "ID",
                    name: "Name"
                }
            },
            filters: {
                fields: {
                    id: {
                        label: "ID",
                        placeholder: "Enter the ID",
                        url: "id"
                    },
                    name: {
                        label: "Name",
                        placeholder: "Enter the name",
                        url: "name"
                    },
                    active: {
                        label: "Status",
                        placeholder: "Select the status",
                        url: "status"
                    }
                }
            },
            dialog: {
                delete: {
                    title: "Deactivate Committee",
                    body: "Are you sure you want to deactivate the committee with ID {{id}}",
                    save: {
                        text: "Yes, deactivate"
                    },
                    back: {
                        text: "Back"
                    },
                }
            }
        },
        save: {
            form: {
                fields: {
                    name: {
                        label: "Name",
                        placeholder: "Enter the name"
                    },
                    userIds: {
                        label: "Users",
                        placeholder: "Select the users"
                    },
                    categoryIds: {
                        label: "Categories",
                        placeholder: "Select the categories"
                    },
                }
            }
        },
        dictionaries: {
            breadcrumb: "Dictionaries",
            messages: {
                create: "Dictionary created successfully",
                update: "Dictionary updated successfully",
                delete: "Dictionary removed successfully",
                recover: "Dictionary restored successfully"
            },
            list: {
                table: {
                    columns: {
                        id: "ID",
                        language: "Language",
                        name: "Name"
                    }
                },
                dialog: {
                    delete: {
                        title: "Remove dictionary",
                        body: "Are you sure you want to remove the dictionary with ID {{id}}?",
                        save: {
                            text: "Yes, remove"
                        },
                        back: {
                            text: "Back"
                        }
                    }
                }
            },
            save: {
                form: {
                    fields: {
                        languageId: {
                            label: "Language",
                            placeholder: "Select the language"
                        },
                        name: {
                            label: "Name",
                            placeholder: "Enter the name"
                        }
                    }
                }
            }
        }
    }
}
